import { render, staticRenderFns } from "./workflow_intervention_by_artisan.vue?vue&type=template&id=cb4a53a2&scoped=true&"
import script from "./workflow_intervention_by_artisan.vue?vue&type=script&lang=js&"
export * from "./workflow_intervention_by_artisan.vue?vue&type=script&lang=js&"
import style0 from "./workflow_intervention_by_artisan.vue?vue&type=style&index=0&id=cb4a53a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4a53a2",
  null
  
)

export default component.exports